import { useQuery } from "react-query";
import { getActivePhoneSetNumber } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActivePhoneSetNumber = () => {
  return useQuery("GetActivePhoneSetNumber", getActivePhoneSetNumber, {
    refetchOnWindowFocus: false,
  });
};
